import React, { useState } from "react";
import { CriteriaSettings } from "./CriteriaSettings";
import { JudgeProfilesSettings } from "./JudgeProfilesSettings";
import { AwardsSettings } from "./AwardsSettings";
import { SpecialAwardsSettings } from "./SpecialAwardsSettings";
import { RulesSettings } from "./RulesSettings";
import { JudgeStationSettingsTab } from "./JudgeStationSettingsTab";

/**
 * Main settings page for competition judging and awards
 */
export default function JudgingAwardsSettings() {
  const [activeTab, setActiveTab] = useState("criteria");

  return (
    <div className="container mx-auto p-6 space-y-8">
      {/* Header */}
      <div className="rounded-box p-6 bg-base-100 border border-base-300">
        <div className="flex flex-col lg:flex-row justify-between gap-6">
          <div>
            <h1 className="text-4xl font-bold text-base-content">
              Judging & Awards
            </h1>
            <p className="text-base-content/60 mt-2">
              Configure scoring criteria, judge profiles, scoring rules, and award tiers for competitions
            </p>
          </div>
        </div>
      </div>

      {/* Tabs */}
      <div className="card bg-base-100 border border-base-300">
        <div className="card-body p-6">
          <div className="tabs tabs-boxed">
            <button
              className={`tab ${activeTab === "criteria" ? "tab-active" : ""}`}
              onClick={() => setActiveTab("criteria")}
            >
              Criteria
            </button>
            <button
              className={`tab ${activeTab === "judges" ? "tab-active" : ""}`}
              onClick={() => setActiveTab("judges")}
            >
              Judges
            </button>
            <button
              className={`tab ${activeTab === "awards" ? "tab-active" : ""}`}
              onClick={() => setActiveTab("awards")}
            >
              Awards
            </button>
            <button
              className={`tab ${activeTab === "special-awards" ? "tab-active" : ""}`}
              onClick={() => setActiveTab("special-awards")}
            >
              Special Awards
            </button>
            <button
              className={`tab ${activeTab === "rules" ? "tab-active" : ""}`}
              onClick={() => setActiveTab("rules")}
            >
              Rules
            </button>
            <button
              className={`tab ${activeTab === "station" ? "tab-active" : ""}`}
              onClick={() => setActiveTab("station")}
            >
              Station
            </button>
          </div>
        </div>
      </div>

      {/* Tab Content */}
      {activeTab === "criteria" && <CriteriaSettings />}
      {activeTab === "judges" && <JudgeProfilesSettings />}
      {activeTab === "rules" && <RulesSettings />}
      {activeTab === "awards" && <AwardsSettings />}
      {activeTab === "special-awards" && <SpecialAwardsSettings />}
      {activeTab === "station" && <JudgeStationSettingsTab />}
    </div>
  );
}
